export default {
  "base": "max-w-(--ui-container) mx-auto px-4 sm:px-6 lg:px-8"
}